import { get, getDatabase, onValue, ref } from "firebase/database";
import React, { useEffect, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { auth, db, onAuthStateChanged } from "../../utilities/firebaseConfig";
import { useNavigate } from "react-router-dom";
function MyAccount({ isOpen, onClose, children }) {
  const [activeJobs, setActiveJobs] = useState([]);

  const [userData, setUserData] = useState(null);
  const [btnactive, setBtnActive] = useState("Login");
  const [chatnotbtn, setChatNotBtn] = useState("Right away");
  const navigate = useNavigate();
  const user = auth.currentUser;
  const navlinkstas = [
    {
      id: 0,
      name: "Login",
    },
    {
      id: 1,
      name: "Email notifications",
    },
    {
      id: 2,
      name: "Subscription",
    },
  ];

  const chatnotbtnn = [
    {
      id: 0,
      name: "Right away",
    },
    {
      id: 1,
      name: "Never",
    },
  ];

  const googleMapsApiKey = "AIzaSyCq1eeQipLUK-43-lJPCGWIZAVzJuuhWpY";

  useEffect(() => {
    const fetchActiveJobs = () => {
      const user = auth.currentUser;
      if (!user) {
        return;
      }

      // Reference to the "jobs" node in the database.
      const jobsRef = ref(db, "jobs");
      onValue(jobsRef, async (snapshot) => {
        if (snapshot.exists()) {
          // Convert jobs object to an array of job objects with their id.
          const jobsData = Object.entries(snapshot.val()).map(([id, job]) => ({
            id,
            ...job,
          }));

          // Filter for jobs that belong to the current user and have status "accepted".
          const filteredJobs = jobsData.filter(
            (job) => job.userId === user.uid
          );

          // For each filtered job, fetch the technician details (if technicianId exists).
          const jobsWithTechDetails = await Promise.all(
            filteredJobs.map(async (job) => {
              if (job.technicianId) {
                const techRef = ref(db, `technicians/${job.technicianId}`);
                const techSnapshot = await get(techRef);
                if (techSnapshot.exists()) {
                  return { ...job, technician: techSnapshot.val() };
                }
              }
              return job;
            })
          );

          setActiveJobs(jobsWithTechDetails);
          console.log(activeJobs.length);
        } else {
          setActiveJobs([]);
        }
      });
    };

    fetchActiveJobs();
  }, [navigate, user]);
  useEffect(() => {
    const currentUser = auth.currentUser;

    if (!currentUser) {
      console.warn("No user is currently signed in");
      return;
    }

    const userRef = ref(db, `users/${currentUser.uid}`);
    const unsubscribe = onValue(
      userRef,
      (snapshot) => {
        if (snapshot.exists()) {
          setUserData(snapshot.val());
        } else {
          console.log("User data not found");
        }
      },
      (error) => {
        console.error("Error fetching user data:", error);
      }
    );

    // Clean up listener on unmount
    return () => unsubscribe();
  }, []);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [isOpen]);

  function formatDate(dateString) {
    const date = new Date(dateString);
    // Arrays for the short names of days and months.
    const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    // Get the components of the date.
    const dayName = days[date.getDay()];
    const monthName = months[date.getMonth()];
    const day = String(date.getDate()).padStart(2, "0");
    const year = date.getFullYear();

    return `${dayName}, ${monthName} ${day}, ${year}`;
  }
  const [checked, setChecked] = useState(false);

  const handleChange = (e) => {
    setChecked(e.target.checked);
  };
  if (!isOpen) return null;
  return (
    <>
      <div className='modal-overlay' onClick={onClose}>
        <div
          className='modal-content'
          onClick={(e) => e.stopPropagation()} // Prevent closing on content click
        >
          <button className='modal-close' onClick={onClose}>
            <svg
              xmlns='http://www.w3.org/2000/svg'
              viewBox='0 0 24 24'
              width='32'
              height='32'
              fill='currentColor'
            >
              <path d='M10.5859 12L2.79297 4.20706L4.20718 2.79285L12.0001 10.5857L19.793 2.79285L21.2072 4.20706L13.4143 12L21.2072 19.7928L19.793 21.2071L12.0001 13.4142L4.20718 21.2071L2.79297 19.7928L10.5859 12Z'></path>
            </svg>
          </button>
          <div className='theaccountcnt'>
            <h1 className='acntitle'>Account settings</h1>
            <p className='acntparag'>
              View and update your account details, profile and more.
            </p>

            <div className='thespacee'></div>
            <div className='theacountcntbdy'>
              <div className='theacountcntbdyleft'>
                <div className='thespacee'></div>
                <div className='thespacee'></div>
                <h1 className='acpname'>
                  {userData?.name} {userData?.lastName}
                </h1>
                <p className='acpemail'>{userData?.email}</p>
                <div className='thespac'></div>
                <div className='dividar'></div>
                <div className='thespacee'></div>
                <h1 className='acpnu'>{activeJobs.length}</h1>
                <p className='acptst'>Tasks</p>
                <div className='thespacee'></div>
                <div className='dividar'></div>
                <div className='thespacee'></div>
                <p className='acptlsas'>
                  Profixexpress user since {formatDate(userData.createdAt)}
                </p>
                <div className='thespacee'></div>
                <div className='thespacee'></div>
              </div>
              <div className='theacountcntbdyright'>
                <div className='theclientdasnav'>
                  <div className='theclientdasleft'>
                    {navlinkstas.map((link, index) => (
                      <button
                        className={`
                                       ${
                                         btnactive === link.name
                                           ? "activebtn"
                                           : "notactivebtn"
                                       } theclientbtnnav`}
                        key={link.id}
                        onClick={() => setBtnActive(link.name)}
                      >
                        {link.name}
                      </button>
                    ))}
                  </div>
                </div>

                {btnactive === "Login" && (
                  <>
                    {" "}
                    <div className='thespacee'></div>
                    <div className='thespacee'></div>
                    <form action='' className='theclifrm' onSubmit={() => {}}>
                      <div className='inputcntfrm'>
                        <label htmlFor=''>Email address</label>
                        <div className='inputfrmemail'>
                          <p className='inputfrmtest'>{userData?.email}</p>
                        </div>
                      </div>
                      <div className='thespacee'></div>
                      <div className='theflexam'>
                        <div className='inputcntfrm'>
                          <label htmlFor=''>Password</label>
                          <input
                            className='inputfrmemail'
                            placeholder='XXXXXXXXX'
                          ></input>
                        </div>
                        <button className='submitbutton' type='submit'>
                          Update
                        </button>
                      </div>
                    </form>
                    <div className='thespacee'></div>
                    <div className='dividar'></div>
                    <div className='thegap'></div>
                    <button className='thedelfmactn'>Delete account</button>
                    <div className='thegap'></div>
                    <div className='dividar'></div>
                  </>
                )}
                {btnactive === "Email notifications" && (
                  <>
                    <div className='thespacee'></div>
                    <div className='theeactcnt'>
                      <div className='theactcntleft'>
                        <p className='tehactisti'>Activity updates</p>
                        <p className='theasoens'>New jobs sync and updates</p>
                      </div>
                      <div className='theactcntright'>
                        <label className='custom-checkbox'>
                          <input
                            type='checkbox'
                            checked={checked}
                            onChange={handleChange}
                          />
                          <span className='checkmark'></span>
                        </label>
                      </div>
                    </div>
                    <div className='thespacee'></div>
                    <div className='theactcntleft'>
                      <p className='tehactisti'>Required communication</p>
                      <p className='theasoens'>
                        Emails regarding your account like billing, security,
                        and support.
                      </p>
                    </div>
                    <div className='thespacee'></div>
                    <div className='dividar'></div>
                    <div className='thespacee'></div>
                    <div className='theactcntleft'>
                      <p className='tehactisti'>Chat notification</p>
                      <p className='theasoens'>
                        Configure the frequency in which comments are sent to
                        your inbox.
                      </p>
                    </div>
                    <div className='thespace'></div>
                    <div className='thsemsbtns'>
                      {chatnotbtnn.map((chtbt, index) => (
                        <button
                          className={
                            chatnotbtn === chtbt.name ? "chtactv" : "chtnactv"
                          }
                          key={chtbt.id}
                          onClick={() => setChatNotBtn(chtbt.name)}
                        >
                          {chtbt.name}
                        </button>
                      ))}
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default MyAccount;
